import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import ClientAuthCallback from "@/pages/ClientAuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PublishedPage from "@/pages/PublishedPage";
import PreviewPage from "@/pages/PreviewPage";
import TemplatePreviewPage from "@/pages/TemplatePreviewPage";
import Cgv from "@/pages/Cgv";
import MentionsLegales from "@/pages/MentionsLegales";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAuthCallback from "@/pages/AdminAuthCallback";
import RouteSEO from "@/components/RouteSEO";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <RouteSEO />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/cgv" element={<Cgv />} />
          <Route path="/conditions-generales-de-vente" element={<Cgv />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/entreprise/:slug" element={<PublishedPage />} />
          <Route path="/preview/:token" element={<PreviewPage />} />
          <Route path="/apercu-modele/:templateId" element={<TemplatePreviewPage />} />

          {/* Client area (noindex) */}
          <Route path="/mon-compte-client" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/auth/callback" element={<ClientAuthCallback />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />

          {/* Admin area (hidden, noindex) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/callback" element={<AdminAuthCallback />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-right" />
    </div>
  );
}

export default App;
